import { Box } from '@warp-ds/react';
import { FinnLogo } from 'shared/icons/FinnLogo';
import { PublishButton } from '@/components/button/PublishButton';

export const FinnBoxMatrix = () => (
    <Box bordered className="flex flex-col h-full !p-0">
        <div className="flex flex-col md:flex-row gap-16 md:gap-24 flex-1 px-16 pt-16 md:px-24 md:pt-24">
            <div className="flex-1 flex flex-col justify-between">
                <div>
                    <div className="flex justify-between gap-16">
                        <div className="flex-shrink-0">
                            <div className="mb-24" aria-hidden>
                                <FinnLogo size="qasa" />
                            </div>
                            <h2 className="h3 mb-8 flex items-center">Annonse på FINN</h2>
                        </div>
                        <div className="flex-shrink-0">
                            <img
                                src="https://images.finncdn.no/dynamic/1280w/lotr/qasa/ps-visual-finn.png"
                                alt=""
                                width={140}
                                className="w-auto h-auto max-w-[140px]"
                            />
                        </div>
                    </div>
                    <p className="h4 mt-16 mb-8">Med FINN når du hele Norge</p>
                    <p>Du håndterer hele prosessen selv og betaler kun for annonse på FINN.</p>
                </div>
                <div className="mt-auto">
                    <div className="mb-8">
                        <PublishButton />
                    </div>
                    <div className="text-14 min-h-[120px] md:min-h-[100px]">
                        <div>Annonse leilighet og hus: 656 kr - 1606 kr</div>
                        <div>Annonse hybel og rom i bofellesskap: 182 kr - 656 kr</div>
                        <div>Annonseprisen avhenger av utleiepris, boligtype, størrelse og annonsepakke</div>
                    </div>
                </div>
            </div>
        </div>
        <div className="text-center py-8 mt-24 flex justify-center gap-8 rounded-b-8 min-h-[48]" style={{ backgroundColor: '#F0F0EB' }}>
            <div className="text-s mt-8">En del av</div>
            <img src="/realestate/lettings/icons/qasa/vend.svg" height="24px" width="61px" alt="Vend logo" />
        </div>
    </Box>
);
